import React from 'react';
import { useTranslation } from 'react-i18next';
import Btn from '../Btn/Btn';
import Modal from '../Modal/Modal';
import { PatientInfo } from './types';

type Props = {
    patient: PatientInfo | null;
    currentWeek: number | null;
    isStarting: boolean;
    error: string | null;
    onClose: () => void;
    onConfirm: () => Promise<void>;
};

const StartNachsorgeModal = ({
    patient,
    currentWeek,
    isStarting,
    error,
    onClose,
    onConfirm,
}: Props): JSX.Element | null => {
    const { t } = useTranslation();

    if (!patient || currentWeek === null) {
        return null;
    }

    return (
        <Modal title={t('Start aftercare')} close={isStarting ? () => undefined : onClose}>
            <div className="frontpage__nachsorge-confirmation">
                <p>
                    <strong>{t('Start aftercare for {{patient}}?', { patient: patient.name })}</strong>
                </p>
                <div className="frontpage__warning-box">
                    <p>
                        {t(
                            'The aftercare tasks will be created first. Only then will the patient move directly to week 15.',
                        )}
                    </p>
                </div>
                <div className="frontpage__assign-details">
                    <div>
                        <strong>{t('Current therapy week')}</strong>
                    </div>
                    <div>{currentWeek}</div>
                </div>
                <div className="frontpage__assign-details">
                    <div>
                        <strong>{t('Target week')}</strong>
                    </div>
                    <div>15</div>
                </div>
                {error && (
                    <div className="frontpage__error" role="alert">
                        {error}
                    </div>
                )}
                <div className="frontpage__assign-actions">
                    <Btn
                        title={isStarting ? t('Starting aftercare...') : t('Start aftercare')}
                        variant="primary"
                        onClick={onConfirm}
                        disabled={isStarting}
                    />
                    <Btn title={t('Cancel')} variant="secondary" onClick={onClose} disabled={isStarting} />
                </div>
            </div>
        </Modal>
    );
};

export default StartNachsorgeModal;
